import * as React from 'react';
import {Enumeration} from '../Api/ControllerTypes/EnumerationTypes';

export interface IEnum {
    exchangeList: Enumeration[];
    slaTypes: Enumeration[];
    workStreams: Enumeration[];
    quoteStatuses: Enumeration[];
    jobTypes: Enumeration[];
    jobStatuses: Enumeration[];
    jobPriority: Enumeration[];
    costTypes: Enumeration[];
    busStopValues: Enumeration[];
    permitStatuses: Enumeration[];
    commercial: Enumeration[];
    extInvoice: Enumeration[];
    dfeStatuses: Enumeration[];
    dfePartialReasons: Enumeration[];
    crewTypes: Enumeration[];
    contactTypes: Enumeration[];
    councilList: Enumeration[];
    drawnByValues: Enumeration[];
    fileTypes: Enumeration[];
    fileFolders: Enumeration[];
    fileStatuses: Enumeration[];
    tmUsage: Enumeration[];
    noteStatuses: Enumeration[];
    feeTypes: Enumeration[];
}

export type EnumType = {
    enums: IEnum | null;
    setEnums: (enums: IEnum) => void;
}

export const EnumContext = React.createContext<EnumType> ({
    enums: null,
    setEnums: (enums: IEnum) => null
});

export default EnumContext;
